import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Whisper, Tooltip } from 'rsuite';
import type { LucideIcon } from 'lucide-react';
import styles from './Sidebar.module.scss';

interface NavItemProps {
  id: string;
  link: string;
  name: string;
  icon: LucideIcon;
  active: boolean;
  expanded: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ link, name, icon: Icon, active, expanded }) => {
  const navigate = useNavigate();

  const button = (
    <button
      className={`${styles.navItem} ${active ? styles.navItemActive : ''}`}
      onClick={() => navigate(link)}
      aria-label={expanded ? undefined : name}
      type="button"
    >
      <span className={styles.navIcon}>
        <Icon size={20} />
      </span>
      {expanded && <span className={styles.navLabel}>{name}</span>}
    </button>
  );

  return (
    <li>
      {expanded ? (
        button
      ) : (
        <Whisper trigger="hover" placement="right" speaker={<Tooltip>{name}</Tooltip>}>
          {button}
        </Whisper>
      )}
    </li>
  );
};

export default NavItem;
